import React from 'react'

export const IconLock = () => (
  <svg
    fill="currentColor"
    viewBox="0 0 11 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 7.78v4.44C0 13.2.82 14 1.83 14h7.34A1.8 1.8 0 0 0 11 12.22V7.78A1.8 1.8 0 0 0 9.17 6H1.83A1.8 1.8 0 0 0 0 7.78zm5.5.89c.5 0 .92.4.92.89 0 .32-.2.6-.46.75v1.47c0 .24-.2.44-.46.44a.45.45 0 0 1-.46-.44V10.3a.87.87 0 0 1-.46-.75c0-.5.41-.9.92-.9zM9 5H7.25V3.46c0-.96-.79-1.73-1.75-1.73-.97 0-1.75.77-1.75 1.73V5H2V3.46C2 1.56 3.57 0 5.5 0S9 1.55 9 3.46V5z"></path>
  </svg>
)
